import { Component } from '@angular/core';
import { Option, StaticStringSelectComponent } from '../static-string-select/static-string-select.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Status } from '@vendasta/sales-orders';

export const OrderStatusLabelMap = {
  [Status.RESUBMITTED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.RESUBMITTED',
  [Status.SUBMITTED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.SUBMITTED',
  [Status.SUBMITTED_FOR_CUSTOMER_APPROVAL]:
    'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.SUBMITTED_FOR_CUSTOMER_APPROVAL',
  [Status.APPROVED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.APPROVED',
  [Status.PROCESSING]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.PROCESSING',
  [Status.ACTIVATION_ERRORS]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.ACTIVATION_ERRORS',
  [Status.ARCHIVED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.ARCHIVED',
  [Status.FULFILLED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.FULFILLED',
  [Status.DECLINED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.DECLINED',
  [Status.SCHEDULED_ACTIVATION]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.SCHEDULED_ACTIVATION',
  [Status.DRAFTED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.DRAFTED',
  [Status.CANCELLATION_REQUESTED]:
    'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.CANCELLATION_REQUESTED',
  [Status.CANCELLED]: 'AUTOMATIONS.EDITOR.TRIGGERS.ORDER_STATUS_CHANGED.STATUS_OPTIONS.CANCELLED',
};

export const OrderStatusOptions: Option[] = Object.entries(OrderStatusLabelMap).map((entry) => ({
  value: entry[0],
  label: entry[1],
}));

@Component({
  selector: 'automata-order-status-options',
  templateUrl: '../static-string-select/static-string-select.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class OrderStatusOptionsComponent extends StaticStringSelectComponent {
  options: Option[] = OrderStatusOptions;
  label = 'AUTOMATIONS.EDITOR.FILTERS.ORDER_DATA.DATA_LABELS.STATUS';
  required = true;
}
